import { FOCUS_GROUP_ARTIFACT_KEY_PREFIX } from '@inference.engine/widgets/web';
import { Spinner } from '@monksflow/monks-ui';
import { FocusGroupReportContent, useFocusGroup } from '@/features/focus-group';
import { ArtifactPreviewFallback } from './ArtifactPreviewFallback';

interface Props {
  artifactKey: string;
}

export function FocusGroupArtifactPreview({ artifactKey }: Props) {
  const focusGroupId = artifactKey.startsWith(FOCUS_GROUP_ARTIFACT_KEY_PREFIX)
    ? artifactKey.slice(FOCUS_GROUP_ARTIFACT_KEY_PREFIX.length)
    : null;

  const query = useFocusGroup(focusGroupId ?? undefined);

  if (!focusGroupId) return <ArtifactPreviewFallback />;

  if (query.isPending) {
    return (
      <div className="flex flex-1 items-center justify-center p-8">
        <Spinner />
      </div>
    );
  }

  if (query.isError) {
    return <ArtifactPreviewFallback />;
  }

  // Reuse the full report body so the in-project preview mirrors the dedicated
  // focus group view (executive summary + interviews tabs).
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <FocusGroupReportContent focusGroup={query.data} />
    </div>
  );
}
